/* DutchThrift: sparkles op de winkelwagenknop (was inline in snippets/dt-brand.liquid). Geladen met defer. */
(function () {
  function injectSparkles(component) {
    if (!component || component.querySelector('.dt-atc-sparkles')) return;
    var wrap = document.createElement('span');
    wrap.className = 'dt-atc-sparkles';
    wrap.setAttribute('aria-hidden', 'true');
    var emojis = ['✨', '⭐', '✨', '🛒', '⭐', '✨'];
    for (var i = 0; i < emojis.length; i++) {
      var s = document.createElement('span');
      s.textContent = emojis[i];
      wrap.appendChild(s);
    }
    component.appendChild(wrap);
  }

  function fireSparkles(component) {
    var wrap = component.querySelector('.dt-atc-sparkles');
    if (!wrap) return;
    wrap.classList.remove('is-firing');
    void wrap.offsetWidth;
    wrap.classList.add('is-firing');
    setTimeout(function () { wrap.classList.remove('is-firing'); }, 1100);
  }

  function watch(component) {
    var btn = component.querySelector('button[name="add"]');
    if (!btn) return;
    injectSparkles(component);
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].type === 'attributes' && muts[i].attributeName === 'class') {
          if (btn.classList.contains('atc-added')) fireSparkles(component);
        }
      }
    });
    mo.observe(btn, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    var components = document.querySelectorAll('.buy-buttons-block add-to-cart-component');
    for (var i = 0; i < components.length; i++) watch(components[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
